import React, { useState, useEffect, useReducer } from 'react';

import SupportComp from './DynamicForm/DynamicAutocomplete';

const TestPage = () => {

  const fields = [
    {
      name: 'User',
      api: 'https://api.udaymotors.in/api/v1/user/',
      display: 'full_name',
      value: 'id',
      child: {
        name: 'trasaction',
        api: 'https://api.udaymotors.in/api/v1/getGroupsByUserId/',
        display: 'group__title',
        value: 'group__id',
        child: {
          name: 'trasaction',
          api: 'https://api.udaymotors.in/api/v1/transaction/',
          display: 'description',
          value: 'id',
        }
      }
    }
  ];

  return (
  <SupportComp/>
  )
};

export default TestPage;
